import QueryBuilder from '../query-builder';

const isNonEmptyString = value =>
  value !== undefined && value !== null && String(value).trim() !== '';

const normalizeConceptValue = value => {
  if (value === undefined || value === null) return null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
  }
  return value;
};

const sanitizeConcepts = concepts => {
  const conceptList = Array.isArray(concepts) ? concepts : [];
  return conceptList
    .map(item => {
      if (item && typeof item === 'object' && item.not !== undefined) {
        const notValue = normalizeConceptValue(item.not);
        return notValue !== null ? { not: notValue } : null;
      }
      return normalizeConceptValue(item);
    })
    .filter(item => item !== null);
};

const sanitizeDataSources = dataSources => {
  const sourceList = Array.isArray(dataSources) ? dataSources : [];
  return sourceList
    .map(item => {
      if (item && item.not !== undefined) {
        return isNonEmptyString(item.not)
          ? { not: String(item.not).trim() }
          : null;
      }
      const name = item && item.name !== undefined ? item.name : item;
      return isNonEmptyString(name) ? String(name).trim() : null;
    })
    .filter(item => item);
};

const sanitizeAgents = agents => {
  const agentList = Array.isArray(agents) ? agents : [];
  return agentList
    .map(item => {
      const name = item && item.name !== undefined ? item.name : item;
      return isNonEmptyString(name) ? String(name).trim() : null;
    })
    .filter(item => item);
};

const createQuery = (
  scroll,
  withConcepts,
  withDataSources,
  withEntities,
  withAgents,
  timelineLength,
  coordinates,
  areas,
  concepts,
  mode,
  dataSources,
  agents
) => {
  const normalizedConcepts = sanitizeConcepts(concepts);
  const normalizedDataSources = sanitizeDataSources(dataSources);
  const normalizedAgents = sanitizeAgents(agents);

  let query = new QueryBuilder.SearchQuery().withOptions(
    new QueryBuilder.SearchOptions(scroll ? timelineLength + 1 : 0, 20)
  );

  if (coordinates)
    query.withGeoQuery(
      new QueryBuilder.GeoQuery()
        .withOperator('intersects')
        .withMapBounds(
          new QueryBuilder.Box(
            coordinates.south,
            coordinates.west,
            coordinates.north,
            coordinates.east
          )
        )
        .withDrawings(buildWithDrawingsQuery(areas))
    );

  if (withEntities) query.withEntities(['track', 'Observation'], 'or');
  if (withConcepts)
    query.withConcepts(normalizedConcepts, mode === true ? 'or' : 'and');
  if (withDataSources) query.withDataSources(normalizedDataSources, 'or');
  if (withAgents) query.withAgents(normalizedAgents, 'or');

  return query;
};

const buildWithDrawingsQuery = areas => {
  let polygons = [];
  for (var i = 0; i < areas.length; i++) {
    let points = [];
    for (var j = 0; j < areas[i].geometry.coordinates[0].length; j++) {
      let latitude = areas[i].geometry.coordinates[0][j][1];
      let longitude = areas[i].geometry.coordinates[0][j][0];
      points.push(new QueryBuilder.Point(latitude, longitude));
    }
    polygons.push(new QueryBuilder.Polygon(points));
  }
  return polygons;
};

export { createQuery };
